import React from 'react'

const Dashboard5 = () => {
  return (
    <h1>Dashboard5</h1>
  )
}

export default Dashboard5